/**
 * Sets custom session fields for the chat
 * @param {import('@livechat/customer-sdk').CustomerSDK} sdk - The LiveChat SDK instance
 * @param {object} chatParams - Session fields
 * @returns {Promise<boolean>} Promise that resolves to true if successful
 */
export function setChatSessionVariables(sdk, chatParams) {
  return new Promise((resolve, reject) => {
    sdk
      .setCustomerSessionFields({
        sessionFields: /** @type {any} */ (chatParams),
      })
      .then(() => {
        console.info('Session fields set successfully')
        resolve(true)
      })
      .catch((error) => {
        console.error('Error setting session fields: ', error)
        reject(error)
      })
  })
}
